export { isModifierPressed, stopPropagationHandler, repeatUntilEventOnElement, preventDefaultHandler } from './DomEvents';